import { graphql, useStaticQuery } from 'gatsby'

/**
 * @property en_MY
 * @property es_CL
 * @property es_PE
 * @property pt_BR
 */
export const footerLinksQuery = graphql`
  query footerLinksQuery {
    en_MY: allMdx(
      filter: { fileAbsolutePath: { regex: "/en-my/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
          }
        }
      }
    }
    es_CL: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-cl/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
            company
          }
        }
      }
    }
    es_CO: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-co/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
            company
          }
        }
      }
    }
    es_PE: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-pe/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
            company
          }
        }
      }
    }
    es_MX: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-mx/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
            company
          }
        }
      }
    }
    pt_BR: allMdx(
      filter: { fileAbsolutePath: { regex: "/pt-br/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
          }
        }
      }
    }
    es_EC: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-ec/footer-links/" } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            title
            link
            dataTestId
            linkId
            ariaLabel
            dataGtmLabel
            iconType
            linkType
            label
            order
            company
          }
        }
      }
    }
  }
`

const useFooterLinks = () => useStaticQuery(footerLinksQuery)

export default useFooterLinks
